import React from "react";
import { useQuery } from "@apollo/client";
import "./Event.css";
import { GET_ALL_USERS_EVENTS } from "./gql/queries";
import Nav from "../../components/Nav";
import EventCard from "./components/EventCard";
import CreateEvent from "./components/create/CreateEvent";
import HostsEvents from "./components/HostsEvents";
import AddToCalendar from "../../components/AddToCalendar/AddToCalendar";

const Event = () => {

    const { data: eventData, loading, error } = useQuery(GET_ALL_USERS_EVENTS);
    let events = eventData?.allUsersEvents || [];

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <>
            <div className="navAndHeader">
                <Nav />
            </div>
            <div className="mainContainer">
                <h1>Upcoming Events <AddToCalendar calendarKey="events" /></h1>
                {events && events.length > 0 ? (
                    <div className="event-container">
                        {events.map((event) => (
                            <EventCard key={event._id} event={event} />
                        ))}
                    </div>
                ) : (
                    <p className="errMsg" style={{ textAlign: "center", fontSize: "20px", paddingBottom: "20px" }}>
                        <strong>No upcoming events</strong></p>)}
                <CreateEvent />
                <HostsEvents />
            </div>
        </>
    )
};

export default Event;

